import React, {useEffect, useState} from 'react'
import Color from '../../Components/Colors/Color'
import ClipLoader from 'react-spinners/ClipLoader'
import CustomSnackbar from '../Components/Snackbar/Snackbar'
import '../Styles/AdminChangePassword.css'
import '../Components/Overlay/Overlay.css'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { changePassword } from '../Controller/ProfileController'

const AdminChangePassword = () => {

    const navigate = useNavigate();

    const [userId, setUserId] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState({
        old: false,
        new: false,
        confirm: false
    })

    // const [loading, setLoading] = useState(false);
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const handleCloseOverlay = () => {
        setShowOverlay(false);
    }

    const handleOpenOverlay = () => {
        if(newPassword !== confirmNewPassword){
            setSeveritySnackbar("error");
            setMessageSnackbar("The passwords don't match");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
        } else if(!oldPassword || !newPassword || !confirmNewPassword) {
            setSeveritySnackbar("error");
            setMessageSnackbar("Fill all form inputs");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
        } else{
            setShowOverlay(true);
        }
        
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent the default Enter key action
        //   handleEditProfile(e); 
          e.target.blur();
        }
    };

    const tokenChecker = () => {
        let token = localStorage.getItem('authToken');
        if (!token) {
            setSeveritySnackbar("error");
            setMessageSnackbar("Token not found, please log in again!");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return null;
        }

        let decodedToken = jwtDecode(token);

        if (decodedToken && decodedToken.exp * 1000 > Date.now()){
            return decodedToken.sub;
        } else {
            setSeveritySnackbar("error");
            setMessageSnackbar("Token has expired, please log in again!");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return null;
        }
    }

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin-dashboard/profile');
        }

        if(!openSnackbar && failure){
            setFailure(false);
        }

        if(!openSnackbar && finishFlag){
            setFinishFlag(false);
        }
    }, [success && openSnackbar, failure && openSnackbar, finishFlag && openSnackbar]) 

    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])


    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            setEmptyTokenFlag(false);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return
        }
    }, [openSnackbar && emptyTokenFlag])


    const handleChangePassword = async (e) => {
        e.preventDefault();
    
        if(!oldPassword || !newPassword || !confirmNewPassword) return;

        let userId = tokenChecker();

        const passwordForm = {
            "oldPassword": oldPassword,
            "newPassword": newPassword
        }

        try{
            setLoadingOverlay(true);

            const response = await changePassword(userId, passwordForm);
         
            if(response.status === 200){
                setSeveritySnackbar('success')
                setMessageSnackbar(response?.data?.message);
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true);
                setShowOverlay(false);

            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occurred");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No Profile found");
                setSnackbarDuration(3000);
                setFailure(true);
                setShowOverlay(false);
                setOpenSnackbar(true); 
            } else{
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setFinishFlag(true);
                setShowOverlay(false);
                setOpenSnackbar(true);
            }
        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleMoveToProfile = () => {
        navigate('/admin-dashboard/profile')
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    return(
        <>
        <div className={`change-password-page`}>
            <div className={`change-password-page-container card `}>
                <h5>Change Password</h5>
                
                <div className="change-password-label-input-container">
                    <label htmlFor="old-password" className={`change-password-label`}>
                        Old password:
                    </label>
                    <input
                        type={`${showPassword.old ? "text" : "password"}`}
                        placeholder="Enter old password"
                        id="old-password"
                        className={`change-password-input`}
                        onChange={(e) => setOldPassword(e.target.value)}
                        value={oldPassword}
                        autoComplete="new-password"
                        required
                        />
                    <span className={`change-password-eye ${showPassword.old ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}`} onClick={() => setShowPassword(prevState => ({...prevState, old: !showPassword.old}))}></span>
                </div>

                <div className="change-password-label-input-container">
                    <label htmlFor="new-password" className={`change-password-label`}>
                        New password:
                    </label>
                    <input
                        type={`${showPassword.new ? "text" : "password"}`}
                        placeholder="Enter new password"
                        id="new-password"
                        className={`change-password-input`}
                        onChange={(e) => setNewPassword(e.target.value)}
                        value={newPassword}
                        autoComplete="off"
                        required
                        />
                    <span className={`change-password-eye ${showPassword.new ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}`} onClick={() => setShowPassword(prevState => ({...prevState, new: !showPassword.new}))}></span>
                </div>

                <div className="change-password-label-input-container">
                    <label htmlFor="confirm-new-password" className={`change-password-label`}>
                        Confirm new password:
                    </label>
                    <input
                        type={`${showPassword.confirm ? "text" : "password"}`}
                        placeholder="Confirm password"
                        id="confirm-new-password"
                        className={`change-password-input`}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        value={confirmNewPassword}
                        autoComplete="off"
                        onKeyPress={handleKeyPress}
                        required
                        />
                    <span className={`change-password-eye ${showPassword.confirm ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}`} onClick={() => setShowPassword(prevState => ({...prevState, confirm: !showPassword.confirm}))}></span>
                </div>

                <div className="change-password-btn-container">
                    <button className={`discard-change-password-btn`} onClick={handleMoveToProfile}>
                        Discard
                    </button>

                    <button className="reset-change-password-btn" onClick={handleOpenOverlay}>
                        Reset Password
                    </button>
                </div>
            </div>
        </div>

        {showOverlay && (
                <div className="overlay-container" style={{color: Color.thirdText}} onClick={() => setShowOverlay(false)}>
                    <div className={`overlay-content`} onClick={handleStopPropagation}>
                        <h4 className={`delete-overlay-header`}>Change Password</h4>
                        <h6 className={`delete-overlay-text`}>Are you sure to change your password?</h6>
                        <div className="delete-overlay-btn-container">
                            <button className={`delete-overlay-cancel-btn`} onClick={handleCloseOverlay}>
                                No
                            </button>
                            <button className={`delete-overlay-ok-btn`} onClick={handleChangePassword}>
                                Yes 
                            </button>
                        </div>
                        <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                                <ClipLoader color='white' size={100} />
                        </div>
                    </div>
                </div>
            )} 
            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
    </>
    )
}

export default AdminChangePassword;